import React, { useState, useEffect } from "react";
import { ExpensesForm } from "./ExpensesForm";
import ExpensesList from "./ExpensesList";
import {
  useCreateExpense,
  useGetExpenses,
} from "../../hooks/useExpenceApi";
import { toast } from "react-toastify";
import { useAuth } from "../../hooks/AuthContext";
// import Loader from "../ui/Loader";
import Container from "../ui/Container";

const ExpensesPage = () => {

  const [page, setPage] = useState(1);
  const limit = 10; // items per page

  const [localExpenses, setLocalExpenses] = useState([]);
  const { user } = useAuth();

  const filters = {
    page: page, // ✅ Use dynamic page state
    limit: limit,
  };
  
  if (user?.role === "employee" && user?.employeeProfile?._id) {
    filters.employeeId = user.employeeProfile._id;
  }

  const { data, isLoading } = useGetExpenses(filters);

  useEffect(() => {
    if (data?.expenses) {
      setLocalExpenses(data.expenses);
    }
  }, [data]);

  const { mutate: createExpense } = useCreateExpense();

  const handleAddExpense = async (payload) => {
    try {
      await createExpense(payload, {
        onSuccess: (res) => {
          toast.success("Expenses submitted successfully!");
          if (user.role === "employee") {
            // setEmployeeExpenses(prev => [...payload.expenses, ...prev]);
          } else {
            setLocalExpenses(prev => [...payload.expenses, ...prev]);
          }
          // Reset to page 1 to see newly added expense
          setPage(1);
        },
        onError: (err) => {
          toast.error(err.response?.data?.message || err.message);
        },
      });
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    }
  };

  // ✅ Get total pages from API response
  const totalPages = data?.pages || 1;
  
  const onPageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
      // Optional: Scroll to top when page changes
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // if (loading) return <Loader />

  return (
    <Container>
      <ExpensesForm onSubmit={handleAddExpense} isLoading={false} />

      <ExpensesList
        expenses={localExpenses}
        isLoading={isLoading}
        statusFilter={["pending"]}
        paginationData={{ page, pages: totalPages }}
        onPageChange={onPageChange}
      />
</Container>
  );
};

export default ExpensesPage;
